import { isDefined } from '@/common/utils';
import { CompactButton } from '@/components/buttons';
import { ContentPanel } from '@/components/content-panel';
import { ContentCard } from '@/layouts/card';
import { PrimaryLayout } from '@/layouts/primary';
import { TopNavFor } from '@/layouts/primary/top-nav';
import { Avatar, Table, Text, useMantineTheme } from '@mantine/core';
import { IconHelpCircle, IconUserBolt } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';
import { usePastWinnersQuery } from './graphql.generated';

export const PastWinnersPage = () => {
	const { data } = usePastWinnersQuery();
	const { colors } = useMantineTheme();
	const navigate = useNavigate();
	const goToHelp = useCallback(() => navigate({ to: '/help' }), [navigate]);

	const helpButton = useMemo(
		() => (
			<CompactButton leftSection={<IconHelpCircle />} onClick={goToHelp}>
				Help
			</CompactButton>
		),
		[goToHelp]
	);

	return (
		<PrimaryLayout
			bottomNav="home"
			header={{ title: 'Entries & Rewards', children: helpButton }}
			topNav={TopNavFor.ENTRIES_AND_REWARDS}
		>
			<ContentPanel>
				<ContentCard title="Past Winners">
					<Table.ScrollContainer minWidth={300}>
						<Table verticalSpacing="md">
							<Table.Tbody>
								{data?.pastWinners?.filter(isDefined).map((item) => (
									<Table.Tr key={item.id}>
										<Table.Td>
											<Avatar size={50} radius={50} color="gray.0">
												<IconUserBolt color={colors.blue[9]} />
											</Avatar>
										</Table.Td>
										<Table.Td>
											<div>
												<Text fz="sm" fw={700}>
													{item.name}
												</Text>
												<Text c="blue.9" fz="xs">
													{item.postcode}
												</Text>
											</div>
										</Table.Td>
										<Table.Td>
											<div>
												<Text fz="sm">Won</Text>
												<Text c="blue.9" fz="xs" fw={700}>
													{item.prize}
												</Text>
											</div>
										</Table.Td>
									</Table.Tr>
								))}
							</Table.Tbody>
						</Table>
					</Table.ScrollContainer>
				</ContentCard>
			</ContentPanel>
		</PrimaryLayout>
	);
};
